import { UserInterfaceDto } from "@intelligems/ig-types/dtos/user-interfaces";

export const getUserInterfacesPutPayload = (
  userInterfaces: UserInterfaceDto[] | undefined
) => {
  const userInterfacesToSave: UserInterfaceDto[] = [];
  if (userInterfaces) {
    userInterfaces.forEach((userInterface) => {
      if (userInterface && userInterface.widget) {
        userInterfacesToSave.push({
          ...userInterface,
          widgetId: userInterface.widget.id,
        });
      }
    });
  }

  return userInterfacesToSave;
};
